import { createContext } from "react";

/** Inherit natural sizing across nested and embedded canvas boundaries. */
export const CanvasAutoHeightContext = createContext(false);

/**
 * Contract empty/fixed-height row bands into content-sized tracks. Boundaries at every item start
 * and end preserve overlaps and side-by-side alignment; column placement is untouched.
 */
export function compactContentRows<
  T extends { id: string; gridRow: number; rowSpan: number },
>(items: T[]): T[] {
  const boundaries = Array.from(
    new Set(
      items.flatMap((item) => [item.gridRow, item.gridRow + item.rowSpan]),
    ),
  ).sort((a, b) => a - b);
  const lines = new Map<number, number>();
  let line = 1;
  boundaries.forEach((start, index) => {
    lines.set(start, line);
    const end = boundaries[index + 1];
    if (
      end !== undefined &&
      items.some(
        (item) => item.gridRow <= start && item.gridRow + item.rowSpan >= end,
      )
    )
      line++;
  });
  return items.map((item) => ({
    ...item,
    gridRow: lines.get(item.gridRow)!,
    rowSpan: lines.get(item.gridRow + item.rowSpan)! - lines.get(item.gridRow)!,
  }));
}
